"use client";

import { isChunkLoadError, reloadOnceForChunkError } from "@/lib/chunk-error";
import { useEffect } from "react";

/**
 * Global recovery for chunk load failures that surface as unhandled rejections
 * or window errors (i.e. dynamic imports that fail outside a React render and
 * therefore never reach an error boundary). Mounted once in the root layout.
 */
export default function ChunkErrorRecovery() {
    useEffect(() => {
        const onRejection = (event: PromiseRejectionEvent) => {
            if (isChunkLoadError(event.reason)) {
                event.preventDefault();
                reloadOnceForChunkError();
            }
        };

        const onError = (event: ErrorEvent) => {
            if (isChunkLoadError(event.error ?? event.message)) {
                reloadOnceForChunkError();
            }
        };

        window.addEventListener("unhandledrejection", onRejection);
        window.addEventListener("error", onError);

        return () => {
            window.removeEventListener("unhandledrejection", onRejection);
            window.removeEventListener("error", onError);
        };
    }, []);

    return null;
}
